export default __webpack_public_path__ + "static/media/leftTop.125b0a6b.gif";